var wellKnownSymbol = require('../internals/well-known-symbol');

exports.f = wellKnownSymbol;



//////////////////
// WEBPACK FOOTER
// /Volumes/Box/sites/wandsworthhub/app/bedrock/web/app/themes/wandsworthhub/node_modules/core-js/internals/well-known-symbol-wrapped.js
// module id = 154
// module chunks = 0